import { useCallback, useEffect, useState } from "react"
import ProfileLayout from "../components/ProfileLayout"
import styles from "./RekomendasiKarir.module.css"
import HistoryRecommendationCard from "./components/HistoryRecomendationCard"
import { Tabs, Button } from "antd"
import axios from "axios"
import { selectCurrentUser } from "../../../redux/user/user.selectors"
import { useSelector } from "react-redux"

const RekomendasiKarir = () => {
  const [answerUserList, setAnswerUserList] = useState()
  const currentUser = useSelector(selectCurrentUser)

  const getListResultAnswerUser = useCallback(() => {
    axios({
      method: "get",
      url: "/career-diagnosis/answer-list",
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
      },
    })
      .then((response) => {
        console.log(response.data)
        const resultData = response.data
        setAnswerUserList(resultData.data)
      })
      .catch((err) => {
        console.error("Error :", err)
      })
  }, [currentUser?.token])

  const handleRedirectUrl = (type) => {
    const payload = JSON.stringify({
      isContinue: "0",
      productType: type,
    })
    console.log("payload", payload)
    axios({
      method: "post",
      url: `/career-diagnosis/portal`,
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    })
      .then((response) => {
        const data = response.data.data
        if (data && data.portalToken) {
          const url = `https://career-diagnosis.mindoeducation.co.id/portal?token=${data.portalToken}`
          window.location.href = url
        }
      })
      .catch((err) => {
        console.error("Error :", err)
      })
  }

  function formatDateToDDMMYYYY(isoString) {
  const date = new Date(isoString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

  useEffect(() => {
    getListResultAnswerUser()
  }, [getListResultAnswerUser])

  const tabItems = [
    {
      key: "career",
      label: "Career Diagnosis",
      children: (
        <div>
          {/* ===== BUTTON ADD ===== */}
          <div className={styles.btn}>
            <Button
              onClick={() => handleRedirectUrl("CAREER_DIAGNOSIS")}
              type="primary">
              Tambah Career Diagnosis
            </Button>
          </div>
          {/* ===== CARD LIST ===== */}
          <div className={styles.cardGrid}>
            {answerUserList?.answer.map((item, key) => (
              <HistoryRecommendationCard
                key={key}
                variant="CAREER_DIAGNOSIS"
                title="Career Diagnosis"
                status={item.status}
                score={item.resultAnswerUsers?.score || 0}
                level={item.resultAnswerUsers?.level}
                lastUpdate={formatDateToDDMMYYYY(item.createdAt)}
                description={item.resultAnswerUsers?.interpretation}
                recommendation={item.resultAnswerUsers?.recommendationProduct}
                buttonText={
                  item.status === "INPROGRESS" ? "Lanjutkan" : "Detail"
                }
                foodPathResult={item.resultFoodPathUser?.recommendationProduct}
                userStatus={item?.userStatus}
                foodIndustryExperience={item?.foodIndustryExperience}
                field={item?.field}
                id={item?.id}
                getListResultAnswerUser={getListResultAnswerUser}
              />
            ))}
          </div>
        </div>
      ),
    },
    {
      key: "food",
      label: "Food Path",
      children: (
        <div>
          {/* ===== BUTTON ADD ===== */}
          <div className={styles.btn}>
            <Button
              onClick={() => handleRedirectUrl("FOOD_PATH")}
              type="primary">
              Tambah Food Path
            </Button>
          </div>

          {/* ===== CARD LIST ===== */}
          <div className={styles.cardGrid}>
            {answerUserList?.foodPathData.map((item, key) => (
              <HistoryRecommendationCard
                variant="FOOD_PATH"
                title="Food Path"
                status={item?.status}
                lastUpdate={formatDateToDDMMYYYY(item.createdAt)}
                foodPathResult={
                  item?.resultFoodPathUsers.at(0)?.recommendationProduct
                }
                buttonText={
                  item.status === "INPROGRESS" ? "Lanjutkan" : "Detail"
                }
                id={item?.id}
                getListResultAnswerUser={getListResultAnswerUser}
              />
            ))}
          </div>
        </div>
      ),
    },
  ]

  return (
    <ProfileLayout
      id="karir"
      title="Rekomendasi Karir"
      text="Riwayat Career Diagnosis & Food Path kamu">
      <Tabs type="card" items={tabItems} />
    </ProfileLayout>
  )
}

export default RekomendasiKarir
